function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_581",
  "data-name": "Grupo 581",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_879",
  "data-name": "Caminho 879",
  d: "M159.6,136.023H156.81v-1.568a6.437,6.437,0,0,1-2.171-.9l-1.107,1.107-1.97-1.97,1.124-1.124a6.415,6.415,0,0,1-.85-2.155H150.2V126.63h1.7a6.453,6.453,0,0,1,.9-2.03l-1.248-1.249,1.97-1.97,1.3,1.3a6.309,6.309,0,0,1,1.976-.773v-1.887H159.6v1.923a6.335,6.335,0,0,1,1.916.8l1.362-1.363,1.971,1.97L163.5,124.7a6.317,6.317,0,0,1,.842,1.933H166.2v2.786h-1.792a6.293,6.293,0,0,1-.789,2.056l1.223,1.223-1.971,1.97-1.169-1.169a6.435,6.435,0,0,1-2.109.922Zm-2.07-.717h1.353V133.83l.293-.055a5.689,5.689,0,0,0,2.358-1.034l.248-.185,1.1,1.1.957-.956-1.125-1.126.162-.244a5.622,5.622,0,0,0,.886-2.319l.045-.306h1.687v-1.353h-1.725l-.058-.288a5.623,5.623,0,0,0-.958-2.2l-.178-.247,1.264-1.265-.957-.956-1.273,1.273-.246-.17a5.636,5.636,0,0,0-2.183-.909l-.293-.055V120.74h-1.353v1.774l-.3.048a5.626,5.626,0,0,0-2.244.876l-.244.162-1.205-1.205-.957.956,1.176,1.176-.186.248a5.618,5.618,0,0,0-1.021,2.284l-.058.288H150.92V128.7h1.528l.045.306a5.688,5.688,0,0,0,.947,2.408l.17.246-1.035,1.035.957.956,1.025-1.025.248.178a5.676,5.676,0,0,0,2.42,1l.3.048Z",
  transform: "translate(-150.204 -120.023)"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_582",
  "data-name": "Grupo 582",
  transform: "translate(4.099 4.1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_880",
  "data-name": "Caminho 880",
  d: "M158.2,131.923a3.9,3.9,0,1,1,3.9-3.9A3.9,3.9,0,0,1,158.2,131.923Zm0-7.084a3.184,3.184,0,1,0,3.183,3.184A3.188,3.188,0,0,0,158.2,124.839Z",
  transform: "translate(-154.303 -124.123)"
}));

function SvgCog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "definitions-betslip",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog);
export default __webpack_public_path__ + "static/media/cog.083af083.svg";
export { ForwardRef as ReactComponent };